export default __webpack_public_path__ + "static/media/feature_2.3d9440bd.png";